import React, { useEffect, useState } from 'react';
import { Button, Col, Divider, Modal, Radio, Row, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  addCoupon,
  checkCouponValidity,
  getAllEventCoupons,
} from '../../../Redux/slices/cartSlice';
import { useParams } from 'react-router-dom';
import './style.scss';
import { dateFormatterForCoupon } from '../../../utils/helpers';

const CouponDialog = ({ open, handleClose, total }) => {
  const { coupons } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const [selectedCoupon, setSelectedCoupon] = useState({});

  const { id } = useParams();
  useEffect(() => {
    dispatch(getAllEventCoupons({ id }));
  }, [open]);
  //  addCoupon, removeCoupon;
  const onChange = (e) => {
    console.log('Radio checked:', e.target);

    setSelectedCoupon({
      id: e.target.id.id,
      discount: e.target.value,
      code: e.target.id.code,
    });
  };
  //   const onChange = (e) =>
  //     console.log(e.target.id, e.target.value, e.target.name);
  // setSelectedCoupon({
  //   id: e.target.id,
  //   discount: e.target.value,
  //   code: e.target.name,
  // });
  const handleApply = () => {
    dispatch(
      checkCouponValidity({
        params: { eventId: id, amount: total },
        code: selectedCoupon.code,
      })
    );
    dispatch(addCoupon(selectedCoupon));
    handleClose();
  };
  // dispatch(addCoupon({ id: e.target.id, discount: e.target.value }));
  // dispatch(addCoupon({ id: e.target.value, discount: e.target.name }));
  return (
    <Modal
      title="Apply Coupon"
      open={open}
      onClose={handleClose}
      className="apply-coupon-dialog"
      centered
      width={500}
      footer={null}
      onCancel={handleClose}
      //   footer={[
      //     <Button key="cancel" onClick={handleClose}>
      //       Cancel
      //     </Button>,
      //     <Button key="apply" type="primary" onClick={handleApply}>
      //       Apply
      //     </Button>,
      //   ]}
    >
      <Radio.Group onChange={onChange} style={{ width: '100%' }}>
        {coupons?.map((coupon) => (
          <div className="coupon-container-new">
            <Radio
              value={coupon.discountValue}
              id={{ id: coupon._id, code: coupon.code }}
              //   name={coupon.code}
            >
              <Typography
                className={
                  selectedCoupon.id === coupon._id
                    ? `coupon-code-in-list-selected`
                    : 'coupon-code-in-list'
                }
              >
                {coupon.code}
              </Typography>
              <Typography
                className={
                  selectedCoupon.id === coupon._id ? 'active-saving' : 'saving'
                }
              >
                SAVE INR {coupon.discountValue}
              </Typography>
              <Typography className="coupon-description">
                INR {coupon.discountValue} off on minimum purchase of INR{' '}
                {coupon.minimumOrderAmount}.
              </Typography>
              <Typography className="coupon-validity">
                Expires on {dateFormatterForCoupon(coupon.validTill)}
              </Typography>
              {/* <Typography>{coupon.description}</Typography> */}
            </Radio>

            <Divider style={{ marginBottom: 0 }} />
          </div>
        ))}
      </Radio.Group>
      {/* <Form layout="vertical">
        <Form.Item label="Coupon Code">
          <Input placeholder="Enter coupon code" />
        </Form.Item>
      </Form> */}
      <Row className="apply-coupon-footer" gutter={[18]}>
        <Col md={12}>
          {' '}
          <Button
            key="cancel"
            onClick={handleClose}
            style={{ width: '100%' }}
            className="cancel-button-coupon"
          >
            Cancel
          </Button>
        </Col>
        <Col md={12}>
          <Button
            key="apply"
            type="primary"
            onClick={handleApply}
            style={{ width: '100%' }}
          >
            Apply
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default CouponDialog;
